import { TkvV2ChildState, tkvV2ProductLoading } from '../../app/angebot/children/tkv-v2.adapter';
import type { TransientState } from '../reducers/transient-state.reducer';
import { hasAllLinienPriced } from './childPricing';
import { AngebotOffer, effectiveCurrent, isOfferPriced } from './angebotOffers';

export const hasUnvisitedOffer = (
  offers: readonly AngebotOffer[],
  angebot: Pick<TransientState['angebot'], 'current' | 'visited'>,
): boolean => {
  const current = effectiveCurrent(offers, angebot);
  return offers.some(offer => offer.key !== current && !angebot.visited.includes(offer.key));
};

export const areAllLinienPriced = (offers: ReadonlyArray<Pick<AngebotOffer, 'state'>>): boolean =>
  offers.length > 0 && offers.every(offer => hasAllLinienPriced(offer.state));

export const isPricingSettled = (
  offers: readonly AngebotOffer[],
  transient: Pick<TransientState, 'pricing' | 'angebot'>,
): boolean =>
  !transient.angebot.copyInProgress &&
  offers.every(offer => isOfferPriced(offer, transient.pricing)) &&
  !offers.some(
    offer => offer.kind === 'TKV' && tkvV2ProductLoading(offer.state as TkvV2ChildState),
  );

export const isAdoptionReady = (
  offers: readonly AngebotOffer[],
  transient: Pick<TransientState, 'pricing' | 'angebot'>,
): boolean => areAllLinienPriced(offers) && isPricingSettled(offers, transient);
